import { __makeTemplateObject } from "tslib";
import * as React from 'react';
import styled from '@emotion/styled';
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { spacing } from '@metro-ui/tokens';
import { Card } from '../../Card';
import { Heading, Text } from '../../Typography';
import { Button, IconButton } from '../../Button';
import { CloseSmall } from '../../icons';
import { Layout } from '../../Layout';
import { Separator } from '../../Separator';
var SeparatorContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  padding: ", " 0;\n"], ["\n  display: flex;\n  padding: ", " 0;\n"])), spacing['x-small']);
var ToastSeparator = styled(Separator)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var TextLayout = styled(Layout)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", " ", " ", " 0;\n"], ["\n  padding: ", " ", " ", " 0;\n"])), spacing['x-small'], spacing.small, spacing['x-small']);
var StyledIconButton = styled(IconButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: ", " 0 ", " ", ";\n"], ["\n  margin: ", " 0 ", " ", ";\n"])), spacing['x-small'], spacing['x-small'], spacing['x-small']);
export var ToastNotification = styled(function (props) {
    var id = props.id, className = props.className, icon = props.icon, title = props.title, text = props.text, hasNoCloseButton = props.hasNoCloseButton, isTwoLine = props.isTwoLine, tertiaryAction = props.tertiaryAction, actionName = props.actionName, remove = props.remove, _a = props.duration, duration = _a === void 0 ? 5000 : _a;
    var Icon = icon;
    var removeRef = useRef(remove);
    removeRef.current = remove;
    useEffect(function () {
        var timerId;
        if (duration > 0) {
            timerId = setTimeout(function () { return removeRef.current(); }, duration);
        }
        return function () { return clearTimeout(timerId); };
    }, [duration]);
    return (React.createElement(Card, { id: id, role: "alert", className: className, radius: "large", elevation: "xx-large" },
        React.createElement(Layout, { direction: "row", gap: "none", padding: "none" },
            icon ? (React.createElement(Icon, { color: "disabled", label: "toast-icon", className: "mds-toast-icon" })) : null,
            React.createElement(TextLayout, { gap: isTwoLine ? 'xx-small' : 'x-small', direction: isTwoLine ? 'column' : 'row', justify: "start", align: isTwoLine ? 'start' : 'center' },
                React.createElement(Heading, { element: "h4", variant: "h4", hasNoNativeMargin: true, color: "secondary" }, title),
                text ? (React.createElement(Text, { element: "span", color: "disabled" }, text)) : null),
            actionName ? (React.createElement(React.Fragment, null,
                React.createElement(SeparatorContainer, null,
                    React.createElement(ToastSeparator, { isVertical: true })),
                React.createElement(Button, { onClick: tertiaryAction, type: "button", label: "tertiary-action", size: "medium", variant: "tertiary" }, actionName))) : null,
            !hasNoCloseButton ? (React.createElement(React.Fragment, null,
                React.createElement(SeparatorContainer, null,
                    React.createElement(ToastSeparator, { isVertical: true })),
                React.createElement(Layout, { padding: "none", align: isTwoLine ? 'start' : 'center' },
                    React.createElement(StyledIconButton, { Icon: CloseSmall, label: "close", onClick: remove, size: "label" })))) : null)));
})(function (_a) {
    var hasNoCloseButton = _a.hasNoCloseButton;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    pointer-events: auto;\n    padding: 0 ", ";\n\n    ", "\n    .mds-toast-icon {\n      padding: ", " ", " ", "\n        0;\n    }\n  "], ["\n    pointer-events: auto;\n    padding: 0 ", ";\n\n    ", "\n    .mds-toast-icon {\n      padding: ", " ", " ", "\n        0;\n    }\n  "])), spacing.small, hasNoCloseButton &&
        "\n      padding-right: 0;\n    ", spacing['x-small'], spacing['x-small'], spacing['x-small']);
});
ToastNotification.propTypes = {
    id: PropTypes.string.isRequired,
    icon: PropTypes.func,
    title: PropTypes.string.isRequired,
    text: PropTypes.string,
    duration: PropTypes.number,
    hasNoCloseButton: PropTypes.bool,
    isTwoLine: PropTypes.bool,
    tertiaryAction: PropTypes.func,
    actionName: PropTypes.string,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=ToastNotification.js.map